import { Component, Injector } from '@angular/core';
import { Item, Restaurant } from '../models';

@Component({
  selector: 'app-pricing-list',
  templateUrl: './pricing-list.component.html',
  styleUrls: ['./pricing-list.component.scss'],
})
export class PricingListComponent {
  selectedRestaurant: Restaurant | null = null;

  onRestaurantSelected(restaurant: Restaurant): void {
    this.selectedRestaurant = restaurant;
  }
}
